import AttendanceInput from "./AttendanceInput";
import RoleInput from "./RoleInput";
import StaffSizeInput from "./StaffSizeInput";

export default [
  {
    id: 107,
    title: "How would you describe your role?",
    placeholder: "Role",
    component: RoleInput,
  },
  {
    id: 108,
    title: "Please select your church’s average attendance.",
    placeholder: "Role",
    component: AttendanceInput,
  },
  {
    id: 108.5,
    title: "Church Staff Size",
    description: "",
    component: StaffSizeInput,
  },
];



// WEBPACK FOOTER //
// ./src/assess/question/questions_individual.js